import script from "./RytonCompetitionResults.vue?vue&type=script&setup=true&lang=js"
export * from "./RytonCompetitionResults.vue?vue&type=script&setup=true&lang=js"

import "./RytonCompetitionResults.vue?vue&type=style&index=0&id=1872f1a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1872f1a2"]])

export default __exports__